// 配置好的 axios , 基于axios提供一个请求函数
import axios from "axios";
import store from "@/store";
import router from "@/router";
// 创建一个新的axios实例
const instance = axios.create({
  // 基准地址
  // baseURL: 'http://192.168.6.67:8200',
  headers: { "Access-Control-Allow-Origin": "*" }
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
});
// 跨域请求，允许保存cookie
// axios.defaults.withCredentials = true
// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 修改配置
    // 如果有token信息  在头部cc加上token
    // 获取vuex存储的token
    console.log(1111)
    // const token = store.state.user.access_token;
    // config.headers.Authorization = "Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjFkNjMxZDlkLTRlNDAtNDRlZC05ZWUxLTRkMzBlOTU0MjQyMyJ9.HTujJEg_oEkZZNIn3OC298alSGe_Y2LCIfQKuCMkFbmrJsGfamUR2pHl38L6WbTo5deKkR2f9R7UVSHQWsNefA";
    // if (token) {
    //   config.headers["Authorization"] = `Bearer ${token}`;
    // }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  res => {
    // 剥离一些无用的数据 res = {data:{message:'',data:'需要数据'}}
    // 遇到无响应情况
    return res;
  },
  async err => {
    // TODO 处理token实现
    // 进入这个错误的拦截 情况：接口请求错误，token失效的，根本没有登录
    if (err.response && err.response.status === 401) {
      // token失效的，根本没有登录
      const user = store.state.user.access_token;
      console.log(router.currentRoute.path);
      // 跳转登录的配置  目的：将来需要传参 query 形式  如果是vue组件  this.$route.path
      // 但是不是  导入router实例  ---> router.currentRoute.path 当前页面的地址
      const login = {
        path: "/home",
        query: { redirect: router.currentRoute.path }
      };
      // 防止未登录    必须有refresh_token
      if (!user || !user.refresh_token) {
        router.push(login);
        return Promise.reject(err);
      }
    }
    // 抛出错误  阻碍程序运行
    return Promise.reject(err);
  }
);
// 封装get和post请求
export const get = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    instance
      .get(url, {
        params
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};
// 一般post方法都会传递参数数据，如果有上传文件，isfile为t，说明有文件上传，如果f没有文件上传依然是以json的数据集格式上传
export const post = (url, params = {}, isFile = false) => {
  let data = {};
  if (isFile) {
    data = new FormData();
    for (let i in params) {
      data.append(i, params[i]);
    }
  } else {
    data = params;
  }
  return new Promise((resolve, reject) => {
    instance
      .post(url, data)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export default instance;
